export const faqsPl = [
  {
    q: "Czy możecie rozpocząć projekt, bez pełnej dokumentacji urządzenia?",
    a: "Tak. Do rozpoczęcia pracy wystarczy nawet niekompletna dokumentacja techniczna, przykładowa działająca aplikacja lub możliwość analizy komunikacji z urządzeniem. Pomagamy odtworzyć brakujące informacje i ograniczyć ryzyka.",
  },
  {
    q: "Czy musimy wysłać Wam próbkę sprzętu?",
    a: "Jeśli mamy kompletną dokumentację, możemy rozpocząć pracę bez próbki. W praktyce jednak dostęp do sprzętu znacząco ułatwia analizę i testy. Bez dokumentacji lub próbki urządzenia ryzyko projektu wyraźnie rośnie.",
  },
  {
    q: "Ile trwa stworzenie aplikacji do urządzenia Bluetooth?",
    a: "Cały proces trwa minimum 3 miesiące. Ostateczny czas zależy od liczby funkcji, stopnia skomplikowania urządzenia, jakości dokumentacji oraz integracji z backendem.",
  },
  {
    q: "Czy pomagacie z publikacją w App Store i Google Play?",
    a: "Tak. Przygotowanie do publikacji w sklepach to standardowa część usługi. Pomagamy przejść przez wymagania techniczne i formalne.",
  },
  {
    q: "Czy po projekcie dostajemy kod źródłowy?",
    a: "Tak. Po zakończeniu projektu przekazujemy kod źródłowy oraz dostępy do repozytoriów. Klient ma pełną kontrolę nad aplikacją.",
  },
  {
    q: "Czy możecie przejąć istniejącą aplikację?",
    a: "Tak. Możemy przeanalizować istniejącą aplikację i kod źródłowy. Oceniamy czy lepiej rozwijać obecne rozwiązanie, czy zaplanować nową wersję.",
  },
  {
    q: "Czy robicie tylko aplikację, czy też backend i panel administracyjny?",
    a: "Możemy przygotować samą aplikację, ale jeśli projekt tego wymaga, tworzymy również backend, panel, konta użytkowników i analitykę.",
  },
  {
    q: "Czy podpisujecie NDA?",
    a: "Tak. Możemy podpisać NDA przed rozmową o szczegółach projektu. Korzystamy z własnego wzoru lub pracujemy na dokumencie klienta.",
  },
  {
    q: "Od czego zależy koszt projektu?",
    a: "Od stopnia skomplikowania urządzenia, zakresu aplikacji, jakości dokumentacji, liczby funkcji, wymagań UX/UI, testów oraz terminu realizacji. Wypełnij formularz, by uzyskać wstępną wycenę.",
  },
] as const;

export const faqsEn = [
  {
    q: "Can you start a project without full device documentation?",
    a: "Yes. We can start with incomplete technical documentation, a working sample app, or access to communication with the device. We help recover missing information and reduce project risk.",
  },
  {
    q: "Do we need to send you a hardware sample?",
    a: "If the documentation is complete, we can start without a sample. In practice, access to the hardware makes analysis and testing much easier. Without documentation or a device sample, project risk increases significantly.",
  },
  {
    q: "How long does it take to build an app for a Bluetooth device?",
    a: "The full process takes at least 3 months. The final timeline depends on the number of features, device complexity, documentation quality, and backend integrations.",
  },
  {
    q: "Do you help with publishing to the App Store and Google Play?",
    a: "Yes. Preparing the app for store release is a standard part of our service. We help you meet both technical and formal requirements.",
  },
  {
    q: "Do we receive the source code after the project?",
    a: "Yes. After the project is completed, we hand over the source code and repository access. You keep full control over the application.",
  },
  {
    q: "Can you take over an existing app?",
    a: "Yes. We can review the existing app and source code, then advise whether it is better to continue developing it or plan a new version.",
  },
  {
    q: "Do you build only the app, or also the backend and admin panel?",
    a: "We can build the mobile app only, but when the project requires it, we also prepare the backend, admin panel, user accounts, and analytics.",
  },
  {
    q: "Can you sign an NDA?",
    a: "Yes. We can sign an NDA before discussing project details. We can use our template or work with your document.",
  },
  {
    q: "What affects the project cost?",
    a: "The cost depends on device complexity, app scope, documentation quality, number of features, UX/UI requirements, testing needs, and timeline. Fill in the form to get an initial estimate.",
  },
] as const;
